import { SM, XS, XS_M, XS_L } from "constants/sizes";
import PictureComponent from "components/core/picture/picture-component";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { StyledProductTitle } from "./product-title.scss";
import { isDarkTheme } from "segments/segments-service";
import { WHITE_COLOR_NAME, BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import Colors from "/styles/colors";

const ProductTitle = (props) => {
  const {
    title,
    body,
    productImage,
    useCases,
    color,
    titleConfig,
    isV2,
    largerTags,
    backgroundColor,
    theme,
    useCasesColor,
    useCasesTextColor
  } = props;

  const getUseCaseStyle = () => {
    if (isV2) {
      if (largerTags) {
        return {
          backgroundColor: Colors[useCasesColor] || backgroundColor,
          border: "none",
          padding: "6px 12px",
          fontSize: "1rem",
          fontWeight: 500
        };
      }
      return {
        backgroundColor: Colors[useCasesColor] || backgroundColor,
        border: "none",
        padding: "4px 10px",
        fontSize: "0.875rem"
      };
    }
    return {};
  };

  const renderUseCases = () => {
    return (
      <div className="use-cases" style={{ "--text-color": useCasesTextColor || color }}>
        {useCases?.map(({ useCase }) => (
          <div key={useCase} className="use-case" style={getUseCaseStyle()}>
            {useCase}
          </div>
        ))}
      </div>
    );
  };

  return (
    <StyledProductTitle className="products-title" style={isV2 ? { padding: "16px 0 18px 16px" } : {}}>
      <div className="content-wrapper">
        <PictureComponent src={productImage} />
        <div className="tab-title-text" style={{ gap: titleConfig?.spaceFromParagraph }}>
          <Title
            titleSize={isV2 ? XS_L : XS_M}
            title={title}
            titleClassName="product-title"
            titleWidth={titleConfig?.titleWidth}
            titleColor={isDarkTheme(theme) ? WHITE_COLOR_NAME : BRAND_BLACK_TEXT_COLOR}
          />
          <Paragraph
            textWidth={titleConfig?.textWidth}
            body={body}
            textSize={largerTags ? SM : XS}
            bodyColor={isDarkTheme(theme) ? WHITE_COLOR_NAME : BRAND_BLACK_TEXT_COLOR}
          />
          {!isV2 && renderUseCases()}
        </div>
      </div>
      {isV2 && renderUseCases()}
    </StyledProductTitle>
  );
};

export default ProductTitle;
